import { useNavigate } from "react-router-dom";
import { LogOut, Mail, User } from "lucide-react";
import { SuiteLayout, Glass, GhostButton } from "../../components/suite/SuiteLayout";
import { useAuth } from "../../context/AuthContext";
import { usePlan } from "../../lib/plans";

export default function SuiteAccount() {
  const { user, logout } = useAuth();
  const { plan } = usePlan();
  const nav = useNavigate();
  return (
    <SuiteLayout credits={plan?.available} title="Account">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-10" data-testid="suite-account">
        <p className="font-mono text-xs tracking-[0.3em] text-cyan-400">ACCOUNT</p>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tight">Account</h1>
        <Glass className="mt-8 p-6 flex items-center gap-5">
          {user?.picture ? <img src={user.picture} alt="" className="w-16 h-16 rounded-full border border-white/20" />
            : <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-500 to-purple-600 flex items-center justify-center"><User className="text-white" /></div>}
          <div className="min-w-0">
            <p className="font-display text-2xl font-bold text-white truncate" data-testid="account-name">{user?.name}</p>
            <p className="text-sm text-slate-400 flex items-center gap-1.5 truncate" data-testid="account-email"><Mail size={14} /> {user?.email}</p>
            <p className="mt-1 font-mono text-xs text-emerald-300" data-testid="account-plan">{plan?.plan?.name || "No plan"} · {plan?.available ?? 0} credits usable</p>
          </div>
        </Glass>
        <div className="mt-6 flex flex-wrap gap-3">
          <GhostButton onClick={() => nav("/billing")} data-testid="account-billing-btn">Billing & credits</GhostButton>
          <GhostButton onClick={() => nav("/sync")} data-testid="account-sync-btn">Cloud Sync settings</GhostButton>
          <GhostButton onClick={async () => { await logout(); nav("/"); }} className="hover:border-rose-400/60" data-testid="account-logout-btn"><LogOut size={15} /> Sign out</GhostButton>
        </div>
      </div>
    </SuiteLayout>
  );
}
